import { configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import { combineReducers } from "redux";
import storageSession from "redux-persist/lib/storage/session";

import titleBarSlice from "store/titleBar.slice";
import spinnerSlice from "store/spinner.slice";
import userSlice from "store/user.slice";
import themeSlice from "store/theme.slice";
import modalSlice from "store/modal.slice";
import navabrSlice from "store/navbar.slice";
import { collectionsApi } from "services/collections.service";

export const reducers = combineReducers({
  spinner: spinnerSlice,
  theme: themeSlice,
  titleBar: titleBarSlice,
  user: userSlice,
  modal: modalSlice,
  navbar: navabrSlice,
  [collectionsApi.reducerPath]: collectionsApi.reducer,
});
const persistConfig = {
  key: "root",
  storage: storageSession,
  blacklist: ["accessibility", "header", collectionsApi.reducerPath],
};
const persistedReducer = persistReducer(persistConfig, reducers);

export default configureStore({
  reducer: persistedReducer,
  devTools: process.env.REACT_APP_ENV_VAR !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(collectionsApi.middleware),
});
